<template>
    <div v-if="share">
        <button
            type="button"
            class="text-body absolute right-2 top-2 z-[2147483652] ml-auto inline-flex items-center rounded-full bg-[#dde1e6] p-1 text-sm transition hover:scale-[1.01] hover:ring-1 hover:ring-[#394354]"
            @click="quiz.closeShare()"
            tabindex="0"
        >
            <svg
                aria-hidden="true"
                class="size-4"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fill-rule="evenodd"
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    clip-rule="evenodd"
                ></path>
            </svg>
            <span class="sr-only">Close modal</span>
        </button>
        <div class="mx-auto aspect-square max-w-md bg-cloud">
            <img :src="shareImage" alt="" class="mx-auto mb-6 h-full w-full" />
        </div>
        <p
            v-if="share.body"
            class="mt-4 max-w-md text-center text-gray-700"
            v-html="share.body"
        ></p>
        <h2 class="mt-4 text-center text-xl font-bold text-blue">
            {{ share.headline || "Share your results" }}
        </h2>

        <div class="mt-2 flex items-center justify-center gap-3">
            <button class="" @click="shareTo('linkedin')">
                <span class="sr-only">Share on LinkedIn</span>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 36.77 37.53"
                    class="size-10 rounded-full bg-blue text-white transition-colors hover:bg-white hover:text-blue hover:ring-2 hover:ring-blue"
                >
                    <g>
                        <circle
                            cx="11.39"
                            cy="11.85"
                            r="2.22"
                            fill="currentColor"
                        />
                        <rect
                            x="9.53"
                            y="15.65"
                            width="3.74"
                            height="12.26"
                            fill="currentColor"
                        />
                        <path
                            d="M19.29,17.34v-1.7h-3.71v12.26h3.71v-4.84c0-2.1.28-3.1.79-3.65,0-.01.02-.02.03-.03.77-.84,2.21-.97,2.94-.14.4.45.6,1.1.59,1.89v6.78h3.96v-6.46c0-4.65-1.73-5.92-3.98-6.09-.07,0-.13-.01-.2-.02-1.27-.1-3.05.16-4.13,2.01Z"
                            fill="currentColor"
                        />
                    </g>
                </svg>
            </button>
            <button
                class="text-blue hover:text-royal"
                @click="shareTo('facebook')"
            >
                <span class="sr-only">Share on Facebook</span>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 36.77 37.53"
                    class="size-10 rounded-full bg-blue text-white transition-colors hover:bg-white hover:text-blue hover:ring-2 hover:ring-blue"
                >
                    <g>
                        <path
                            d="M36.77,18.38v.77c0,9.39-7.04,17.13-16.12,18.24-.74.09-1.5.14-2.26.14-.98,0-1.93-.08-2.87-.22C6.72,35.93,0,28.33,0,19.15v-.77C0,8.23,8.23,0,18.38,0c5.08,0,9.67,2.06,13,5.38,3.33,3.33,5.38,7.92,5.38,13Z"
                            fill="transparent"
                        />
                        <path
                            d="M20.65,18.23v2.91h4.42l-.71,4.84h-3.71v11.42c-.74.09-1.5.14-2.26.14-.98,0-1.93-.08-2.87-.22v-11.34h-4.23l.08-4.84h4.15v-4.18c0-3.1,2.79-6.76,9.55-5.24v4.06l-2.05.04c-1.42.03-2.37,1-2.37,2.42Z"
                            fill="currentColor"
                        />
                    </g>
                </svg>
            </button>
            <!-- <button class="text-blue hover:text-royal">
                <span class="sr-only">Instagram</span>
                <svg
                    id="Layer_2"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 36.77 37.53"
                    class="size-10 rounded-full bg-blue text-white transition-colors hover:bg-white hover:text-blue hover:ring-2 hover:ring-blue"
                >
                    <g>
                        <path
                            d="M18.38,15.42c1.85,0,3.34,1.5,3.34,3.34s-1.5,3.34-3.34,3.34-3.34-1.5-3.34-3.34,1.5-3.34,3.34-3.34M18.38,13.58c-2.86,0-5.19,2.33-5.19,5.19s2.33,5.19,5.19,5.19,5.19-2.33,5.19-5.19-2.33-5.19-5.19-5.19h0Z"
                            fill="currentColor"
                        />
                        <path
                            d="M22.81,10.58c2.08,0,3.77,1.69,3.77,3.77v8.85c0,2.08-1.69,3.77-3.77,3.77h-8.85c-2.08,0-3.77-1.69-3.77-3.77v-8.85c0-2.08,1.69-3.77,3.77-3.77h8.85M22.81,8.73h-8.85c-3.09,0-5.61,2.52-5.61,5.61v8.85c0,3.09,2.52,5.61,5.61,5.61h8.85c3.09,0,5.61-2.52,5.61-5.61v-8.85c0-3.09-2.52-5.61-5.61-5.61h0Z"
                            fill="currentColor"
                        />
                        <circle
                            cx="23.84"
                            cy="13.31"
                            r="1.22"
                            fill="currentColor"
                        />
                    </g>
                </svg>
            </button> -->
            <button class="" @click="shareTo('email')">
                <svg
                    id="Layer_2"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 37.53 37.53"
                    class="size-10 rounded-full bg-white text-blue transition-colors hover:bg-blue hover:text-white hover:ring-2 hover:ring-blue"
                >
                    <g id="Layer_1-2">
                        <path
                            d="M18.77,0C8.4,0,0,8.4,0,18.77s8.4,18.77,18.77,18.77,18.77-8.4,18.77-18.77S29.13,0,18.77,0ZM8.16,11.52h21.2c.06,0,.12,0,.18.03l-9.72,8.87c-.61.55-1.52.55-2.12,0L7.99,11.54c.06-.02.12-.03.18-.03ZM7.58,25.43v-12.94l7.97,7.27-7.9,5.93c-.04-.08-.07-.17-.07-.27ZM8.85,26.02l7.43-5.58.77.7c.47.43,1.08.67,1.72.67s1.25-.24,1.72-.67l.77-.7,7.43,5.58H8.85ZM29.95,25.43c0,.09-.02.19-.07.27l-7.9-5.93,7.97-7.27v12.94Z"
                            fill="currentColor"
                        />
                    </g>
                </svg>
            </button>
            <button
                class=""
                @click="copyToClipboard(`${siteUrl}quiz`)"
                title="Copy Link to Quiz"
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 37.53 37.53"
                    class="size-10 rounded-full bg-blue text-white transition-colors hover:bg-white hover:text-blue hover:ring-2 hover:ring-blue"
                    :class="
                        copied
                            ? 'bg-royal text-white ring-2 ring-royal hover:bg-white hover:text-royal hover:ring-royal'
                            : ''
                    "
                >
                    <g>
                        <circle
                            cx="18.77"
                            cy="18.77"
                            r="18.77"
                            fill="transparent"
                        />
                        <path
                            d="M17.91,14.18c.55.04,1.09.16,1.6.35l2.88-2.88c.78-.78,2.2-.64,3.16.33.96.96,1.11,2.38.33,3.16l-4.6,4.6c-.78.78-2.2.64-3.16-.33-.4-.4-1.04-.4-1.43,0-.4.4-.4,1.04,0,1.43.83.83,1.9,1.33,3.01,1.41.56.04,1.1-.03,1.61-.2.54-.19,1.01-.48,1.41-.88l4.6-4.6c.4-.4.69-.87.88-1.41.17-.51.24-1.05.2-1.61-.08-1.11-.58-2.18-1.41-3.01-.83-.83-1.9-1.33-3.01-1.41-.56-.04-1.1.03-1.61.2-.54.19-1.01.48-1.41.88l-3.98,3.98c.3-.03.61-.04.93-.01Z"
                            fill="currentColor"
                        />
                        <path
                            d="M19.62,23.36c-.55-.04-1.09-.16-1.6-.35l-2.88,2.88c-.78.78-2.2.64-3.16-.33-.96-.96-1.11-2.38-.33-3.16l4.6-4.6c.78-.78,2.2-.64,3.16.33.4.4,1.04.4,1.43,0,.4-.4.4-1.04,0-1.43-.83-.83-1.9-1.33-3.01-1.41-.56-.04-1.1.03-1.61.2-.54.19-1.01.48-1.41.88l-4.6,4.6c-.4.4-.69.87-.88,1.41-.18.51-.24,1.05-.2,1.61.08,1.11.58,2.18,1.41,3.01.83.83,1.9,1.33,3.01,1.41.56.04,1.1-.03,1.61-.2.54-.19,1.01-.48,1.41-.88l3.98-3.98c-.3.03-.61.04-.93.01Z"
                            fill="currentColor"
                        />
                    </g>
                </svg>
            </button>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { useQuizStore } from "../stores/quizStore";

const quiz = useQuizStore();

const share = computed(() => quiz.slides.find((s) => s.kind === "shareSlide"));

const siteUrl = quiz.siteUrl;

const shareText = computed(() => {
    if (share.value?.shareMessage) return share.value.shareMessage;
    return `I scored ${quiz.score}/${quiz.totalQuestions} on the carbon footprint quiz!`;
});

const shareUrl = computed(() =>
    siteUrl ? `${siteUrl}quiz` : `${window.location.origin}/quiz`,
);

const shareImage = computed(() => {
    const images = share.value?.images;
    if (images) {
        return images[Math.floor(Math.random() * images.length)].url;
    }
});

function shareTo(platform: "linkedin" | "facebook" | "email") {
    const text = encodeURIComponent(shareText.value);
    const url = encodeURIComponent(shareUrl.value);
    let target = "";

    switch (platform) {
        case "linkedin":
            target = `https://www.linkedin.com/sharing/share-offsite/?url=${url}`;
            break;
        case "facebook":
            target = `https://www.facebook.com/sharer/sharer.php?u=${url}`;
            break;
        case "email":
            target = `mailto:?subject=My quiz results&body=${text}%0A${url}`;
            break;
    }

    window.open(target, "_blank", "noopener,noreferrer");
}

const copied = ref(false);

async function copyToClipboard(text: string) {
    try {
        await navigator.clipboard.writeText(text);
        copied.value = true;

        setTimeout(() => {
            copied.value = false;
        }, 2000);
    } catch (err) {
        console.error("Failed to copy:", err);
    }
}
</script>
